// İSG Portal — yerelleştirme tipleri. KAYNAK: api-contract.md §6.1 / §6.2.

/** Aktif dil — api-contract §6.2 (`GET /languages`). */
export interface LanguageDto {
  /** Kültür kodu (örn. `tr-TR`). */
  culture: string;
  /** Görünen dil adı (örn. `Türkçe`). */
  name: string;
  /** Varsayılan dil mi (dil seçicide öne alınır). */
  isDefault: boolean;
}

/** Dil paketi — api-contract §6.1 (`GET /resources?culture=`). */
export interface ResourcePackDto {
  /** Sunucunun gerçekte çözdüğü kültür. */
  culture: string;
  /** Düz sözlük: anahtar → çevrilmiş metin. Anahtarlar `.` içerebilir (`label.save`). */
  resources: Record<string, string>;
}

/** Desteklenen kültürler (foundation seed'i — api-contract §6). */
export const SUPPORTED_CULTURES = ['tr-TR', 'en-US', 'de-DE'] as const;
export type SupportedCulture = (typeof SUPPORTED_CULTURES)[number];

export const FALLBACK_CULTURE: SupportedCulture = 'tr-TR';
